import type { ShareFinalTarget, ShareTarget } from '../types';

export const HOST_MESSAGES = {
  SUCCESS: 'shareSuccess',
  ERROR: 'shareError',
  CANCEL: 'shareCancel',
};

export const SHARE_TARGET = {
  STARTPAGE: 'SHARE_USER_SUBTEXT_STARTPAGE',
  MESSAGE: 'SHARE_USER_SUBTEXT_MESSAGE',
  GROUPS: 'SHARE_USER_SUBTEXT_GROUPS',
} as const;

export const SHARE_FINAL_TARGET = {
  FEED: 'FEED',
  MESSENGER: 'MESSENGER',
} as const;

export const TARGET_MAP: Record<ShareTarget, ShareFinalTarget> = {
  [SHARE_TARGET.STARTPAGE]: SHARE_FINAL_TARGET.FEED,
  [SHARE_TARGET.MESSAGE]: SHARE_FINAL_TARGET.MESSENGER,
  [SHARE_TARGET.GROUPS]: SHARE_FINAL_TARGET.MESSENGER,
};
